import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/opt/render/project/src/node_modules/.pnpm/gatsby-theme-docz@2.3.1_@babel+core@7.11.1_@types+node@24.7.0_docz@2.4.0_@babel+core@7._04842b0c5656885ffb9b2f355e30df2b/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "generate-csp"
    }}>{`Generate CSP`}</h1>
    <p>{`Our CSP is served through a Cloudflare headers policy. Updating that policy is fairly simple but generating the right CSP can be tricky. This file helps you do just that.`}</p>
    <h2 {...{
      "id": "usage"
    }}>{`Usage`}</h2>
    <ol>
      <li parentName="ol">{`Update `}<inlineCode parentName="li">{`./scripts/generate-csp/index.js`}</inlineCode>{` with your new entries`}</li>
      <li parentName="ol">{`Run `}<inlineCode parentName="li">{`node scripts/generate-csp`}</inlineCode>{` and copy the output`}</li>
      <li parentName="ol">{`Update `}<inlineCode parentName="li">{`kualibuild/identity`}</inlineCode>{` in `}<inlineCode parentName="li">{`src/shared/secure/index.js`}</inlineCode>{` around line 61`}</li>
      <li parentName="ol">{`Update the production-security-headers custom policy in AWS at Cloudfront > Policies > Response headers`}</li>
    </ol>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      